import React from 'react';
import { Box } from '@mui/material';
import { palette, spaces } from '../../../../assets/styles/themes/tokens';
import { colors } from '../../../../assets/styles/themes/variables';
import { externalLinks } from '../../../../constants';
import ReadMoreButton from './ReadMoreButton';
import useScreenSize from '../../../../utils/useScreenSize';

const getStickyFooterStyles = (isSmallScreen: boolean) => ({
  position: 'fixed',
  bottom: 0,
  width: '100%',
  marginTop: 'auto',
  backgroundColor: colors.blue100,
  display: 'flex',
  height: spaces.xxxxl,
  padding: isSmallScreen ? spaces.md : `${spaces.md} 0 ${spaces.md} ${spaces.xxxxxl}`,
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-end',
  alignSelf: 'stretch',
  zIndex: 1000,
  borderTop: `1px solid ${palette.divider}`,
  boxSizing: 'border-box',
});

const getInnerContainerStyles = (isSmallScreen: boolean) => ({
  display: 'flex',
  padding: isSmallScreen ? 0 : `0 ${spaces.xxxl}`,
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: spaces.xs,
  alignSelf: 'stretch',
});

const AIAssistantReadMore: React.FC = () => {
  const { isXsScreen, isSmScreen } = useScreenSize();
  const isSmallScreen = isXsScreen || isSmScreen;

  const handleClick = () => {
    window.open(externalLinks.assistantFaq, '_blank');
  };

  return (
    <Box sx={getStickyFooterStyles(isSmallScreen)} data-testid='history-read-more-footer'>
      <Box sx={getInnerContainerStyles(isSmallScreen)}>
        <ReadMoreButton onClick={handleClick} variant='tertiary' />
      </Box>
    </Box>
  );
};

export default AIAssistantReadMore; 
